Wee.fn.make('eventsIndex', {
	init: function() {
		this.locations = $.get('locations');
		this.bindEvents();
	},

	unload: function() {
		$.events.off(null, '.events');
	},

	bindEvents: function() {
		var scope = this;

		$.events.on({
			'ref:filter': {
				change: function(e, el) {
					var val = el.value;

					if ($(el).data('type') === 'country') {
						$('ref:country').val('').val(val);
						$('ref:state').val('');
						$('ref:type').val('');
					}

					scope.filter();
				}
			},
			'ref:resetFilters': {
				click: function() {
					scope.filter(true);
				}
			}
		}, {
			namespace: 'events'
		});
	},

	filter: function(reset) {
		var query = this.filterFilters($('ref:filters').serialize(true)),
			path = $.routes.uri().path;

		$.history.go({
			path: reset ? path : path + '?' + $.serialize(query),
			scrollTop: false
		});
	},

	filterFilters: function(data) {
		var obj = {};

		for (var item in data) {
			if (data.hasOwnProperty(item)) {
				if (data[item] !== '') {
					obj[item] = data[item];
				}
			}
		}

		return obj;
	}
});